import type { MasterDataVehicle } from "@/pages/master-data-vehicle-list/model";
import { VEHICLE_WEIGHT_CLASSES } from "@/shared/constants/offer-cargo";
import { safeParseInt } from "@/shared/lib/number";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { Button, Stack, Typography } from "@mui/material";
import { Badge } from "./badge";

type Props = {
  vehicle: MasterDataVehicle;
  onVehicleClick: (vehicleId: number) => void;
};

export const MobileVehicleListItem: React.FC<Props> = ({
  vehicle,
  onVehicleClick,
}) => {
  const parsedWeightClass = safeParseInt(vehicle.weightClass);
  const weightClassLabel =
    VEHICLE_WEIGHT_CLASSES.find(
      (weightClass) => weightClass.value === parsedWeightClass,
    )?.label ?? "-";

  return (
    <Stack direction="column" gap={1.5}>
      {/* ナンバー, 車名 */}
      <Typography fontSize="14px" fontWeight={700} color="grey.900">
        {vehicle.number} / {vehicle.name}
      </Typography>

      <Stack direction="column" gap={0.5}>
        {/* トン数(車格) */}
        <Stack direction="row" alignItems="center" gap={1}>
          <Badge label="トン数(車格)" />
          <Typography fontSize="12px" color="grey.900">
            {weightClassLabel}
          </Typography>
        </Stack>

        {/* ボディタイプ */}
        <Stack direction="row" alignItems="center" gap={1}>
          <Badge label="ボディタイプ" />
          <Typography fontSize="12px" color="grey.900">
            {vehicle.shapeText}
          </Typography>
        </Stack>

        {/* その他・特記事項 */}
        <Stack direction="row" alignItems="center" gap={1}>
          <Badge label="その他・特記事項" />
          <Typography fontSize="12px" color="grey.900">
            {vehicle.memo}
          </Typography>
        </Stack>
      </Stack>

      <Button
        sx={{
          alignSelf: "stretch",
          position: "relative",
          py: "10px",
          borderRadius: "24px",
          backgroundColor: "grey.100",
          fontSize: "14px",
          fontWeight: 700,
          color: "grey.900",
        }}
        onClick={() => onVehicleClick(vehicle.id)}
      >
        車両詳細を確認
        <ChevronRight
          width={20}
          height={20}
          sx={{ position: "absolute", right: "10px", top: "10px" }}
        />
      </Button>
    </Stack>
  );
};
